<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch"
      :default-sort="defaultSort"
      @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu"
      @sort-change="sortChange"
      >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderDetail.table.skuName')">
            <BjInput v-model="queryParams.skuName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <BjFormItemCode v-model="queryParams.skuCode" :label="$t('BusinessPurchaseOrderDetail.table.skuCode')" @keyup.enter.native="handleQuery" />
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseForecast.level')">
            <BjSelectLov v-model="queryParams.salesMonthsLevels" :show-disabled="true" :option-list="SALES_GRADE_LIST" multiple :collapse-tags="true" @change="selectSalesMonths" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:beforeSearchBtn>
        <el-col :span="24 - colSpan">
          <BjStatusTabs
            :value="auditTabsValue"
            :option-list="TAB_LIST"
            @handleTabClick="handleTabClick"
          />
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <BjFrontendExport
            type="primary"
            :label-list="exportLabelList"
            :rows="selectedRows"
            :file-name="inventoryExportFileName"
            :auto-format-date="false"
            @export-success="resetAfterExport"
          />
          <el-button type="primary" @click="visibleTooltip = true">{{ $t('BusinessPurchaseForecast.userManual') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>

        <template v-for="(col, index) in dropCols">
          <vxe-table-column v-if="col.prop === 'skuCode'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="skuCode" :title="$t('BusinessPurchaseOrderDetail.table.skuCode')" sortable width="150px" />
          <vxe-table-column v-else-if="col.prop === 'skuAvgDaySales'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="skuAvgDaySales" :title="$t('BusinessPurchaseForecast.skuAvgDaySales')" sortable width="108px" />
          <vxe-table-column v-else-if="col.prop === 'salesMonths'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="salesMonths" :title="$t('BusinessPurchaseForecast.month')" sortable width="120px" />
          <vxe-table-column v-else-if="col.prop === 'salesMonthsLevel'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="salesMonthsLevel" width="100px">
            <template #header>
              <p>
                {{ $t('BusinessPurchaseForecast.level') }}
                <el-tooltip placement="top">
                  <span slot="content">1: 0-1 months<br />2: 1-2 months<br />3: 2-3 months<br />4: 3-6 months<br />5: 6-9 months<br />6: 9-12 months<br />7: 12 months or more<br /></span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </p>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'breakevenPrice'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="breakevenPrice" width="98px">
            <template #header>
              <p>
                {{ $t('BusinessPurchaseForecast.breakevenPrice') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.breakevenPriceTooltip') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </p>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'marginPrice'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="marginPrice" width="150px">
            <template #header>
              <p>
                {{ $t('BusinessPurchaseForecast.marginPrice') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.marginPriceTooltip') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </p>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'deliveryTime'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="deliveryTime" width="145px">
            <template #header>
              <p>
                {{ $t('BusinessPurchaseForecast.deliveryTime') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.deliveryTimeTooltip') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </p>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'operationSuggestions'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="operationSuggestions" width="180px">
            <template #header>
              <p>
                {{ $t('BusinessPurchaseForecast.operationSuggestions') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.operationSuggestionsTooltip') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </p>
            </template>
            <template slot-scope="{ row }">
              <div v-html="setOperationSuggestions(row[col.prop])"></div>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'salesMonthsHistory'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="salesMonthsHistory" :fixed="col.fixed || 'right'" width="200px">
            <template #header>
              <p>
                {{ $t('BusinessPurchaseForecast.salesMonthsHistory') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.salesMonthsHistoryText1') }}: {{ $t('BusinessPurchaseForecast.salesMonthsHistoryTooltip2') }}<br />{{ $t('BusinessPurchaseForecast.salesMonthsHistoryText2') }}: {{ $t('BusinessPurchaseForecast.salesMonthsHistoryTooltip1') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </p>
            </template>
            <template slot-scope="{ row }">
              <el-button type="text" class="edit-btn" @click="onMonth(row[col.prop])"> {{ $t('BusinessPurchaseForecast.salesMonthsHistoryText1') }} </el-button>
              <el-button type="text" class="edit-btn" @click="onGrade(row[col.prop])"> {{ $t('BusinessPurchaseForecast.salesMonthsHistoryText2') }} </el-button>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'shipmentQty'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="shipmentQty" :title="$t('BusinessPurchaseForecast.shipmentQty')" sortable width="140px" />
          <vxe-table-column v-else-if="col.prop === 'onHandQty'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="onHandQty" :title="$t('BusinessPurchaseForecast.onHandQty')" sortable width="115px" />
          <el-table-column v-else-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center"
            class-name="item">
            <template slot-scope="{ row }">
              <template v-if="false" />
              <template v-else-if="col.prop === 'actualProfitRate'">
                {{ row[col.prop] | profitMarginFilter }}
              </template>
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
          </el-table-column>
        </template>
      </template>
  </BjPage>
  <!-- 历史数据弹窗 -->
  <BjDialog :visible="visible" width="1000px" destroy-on-close @close="visible = false">
    <LineChart v-if="visible" :chart-data="lineChartData" />
  </BjDialog>
  <!--用户手册弹窗    -->
  <BjDialog :visible="visibleTooltip" @close="visibleTooltip = false">
    <div class="manual">
     <p class="title">1：{{ $t('BusinessPurchaseForecast.userManualData.p1') }}</p>
     <div>
       <p class="title">2：{{ $t('BusinessPurchaseForecast.userManualData.p2') }}</p>
       <p>2.1：{{ $t('BusinessPurchaseForecast.userManualData.p21') }} </p>
       <p class="formula">{{ $t('BusinessPurchaseForecast.userManualData.p22') }}</p>
       <p class="formula">{{ $t('BusinessPurchaseForecast.userManualData.p23') }}</p>
       <p>2.2：{{ $t('BusinessPurchaseForecast.userManualData.p24') }} </p>
     </div>
     <p class="title">3：{{ $t('BusinessPurchaseForecast.userManualData.p3') }} </p>
     <div>
       <p class="title">4：{{ $t('BusinessPurchaseForecast.userManualData.p4') }} </p>
       <p>4.1: {{ $t('BusinessPurchaseForecast.userManualData.p41') }}</p>
       <p>4.2: {{ $t('BusinessPurchaseForecast.userManualData.p42') }}</p>
       <p>4.3: {{ $t('BusinessPurchaseForecast.userManualData.p43') }}</p>
     </div>
     <div>
       <p class="title">5：{{ $t('BusinessPurchaseForecast.userManualData.p5') }}</p>
       <p>5.1：{{ $t('BusinessPurchaseForecast.userManualData.p51') }}</p>
       <p>5.2：{{ $t('BusinessPurchaseForecast.userManualData.p52') }}</p>
     </div>
    </div>
  </BjDialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi } from '@/api';
import moment from 'moment';
const echarts = require('echarts/lib/echarts');
import LineChart from './components/LineChart.vue';

export default {
  name: 'BusinessInventoryPrediction',
  components: { LineChart },
  mixins: [pageMiXin],
  data() {
    return {
      queryApi: purchaseApi.spurPrediction,
      visible: false,
      visibleTooltip: false,
      // 查询参数
      queryParams: {
        skuCode: null,
        skuName: null,
        skuSort: null,
        shipmentQtySort: null,
        onHandQtySort: null,
        skuAvgDaySalesSort: null,
        salesMonthsSort: null,
        salesMonthsLevels: null,
        salesTypes: ['1', '2', '3', '4']
      },
      labelList: [
        { label: this.$t('BusinessPurchaseOrderDetail.table.skuCode'), prop: 'skuCode', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('BusinessPurchaseOrderDetail.table.skuName'), prop: 'skuName', isCheck: true, disabled: false, width: 160 },
        { label: this.$t('BusinessPurchaseForecast.shipmentQty'), prop: 'shipmentQty', isCheck: true, disabled: false, width: 140 },
        { label: this.$t('BusinessPurchaseForecast.skuAvgDaySales'), prop: 'skuAvgDaySales', isCheck: true, disabled: false, width: 108 },
        { label: this.$t('BusinessPurchaseForecast.onHandQty'), prop: 'onHandQty', isCheck: true, disabled: false, width: 115 },
        { label: this.$t('BusinessPurchaseForecast.month'), prop: 'salesMonths', isCheck: true, disabled: false, width: 120},
        { label: this.$t('salesPriceText'), prop: 'price', isCheck: true, disabled: false, width: 135 },
        { label: this.$t('BusinessPurchaseForecast.actualProfitRate'), prop: 'actualProfitRate', isCheck: true, disabled: false, width: 115 },
        { label: this.$t('BusinessPurchaseForecast.breakevenPrice'), prop: 'breakevenPrice', isCheck: true, disabled: false, width: 98 },
        { label: this.$t('BusinessPurchaseForecast.marginPrice'), prop: 'marginPrice', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('BusinessPurchaseForecast.level'), prop: 'salesMonthsLevel', isCheck: true, disabled: false, width: 135 },
        { label: this.$t('BusinessPurchaseForecast.deliveryTime'), prop: 'deliveryTime', isCheck: true, disabled: false, width: 145 },
        { label: this.$t('BusinessPurchaseForecast.operationSuggestions'), prop: 'operationSuggestions', isCheck: true, disabled: false, width: 180 },
        { label: this.$t('BusinessPurchaseForecast.salesMonthsHistory'), prop: 'salesMonthsHistory', isCheck: true, disabled: false, width: 200 },
      ],
      SALES_GRADE_LIST: [
        { value: '1', label: '1', disabled: false },
        { value: '2', label: '2', disabled: false },
        { value: '3', label: '3', disabled: false },
        { value: '4', label: '4', disabled: false },
        { value: '5', label: '5', disabled: false },
        { value: '6', label: '6', disabled: false },
        { value: '7', label: '7', disabled: false }
      ],
      selection: true,
      auditTabsValue: 'ALL',
      TAB_LIST: [
      {
          label: this.$t('wholeText'),
          value: 'ALL'
        },
        {
          label: this.$t('BusinessPurchaseForecast.fast'),
          value: 'FAST_MOVING'
        },
        {
          label: this.$t('BusinessPurchaseForecast.normal'),
          value: 'NORMAL'
        },
        {
          label: this.$t('BusinessPurchaseForecast.slow'),
          value: 'SLOW_MOVING'
        },
        {
          label: this.$t('BusinessPurchaseForecast.levelFour'),
          value: 'LEVEL_FOUR'
        }
      ],
      lineChartData: {
            title: {
              text: this.$t('BusinessPurchaseForecast.salesMonthsHistory'),
              textStyle: {
                align: 'center',
                color: '#082dc3',
                fontSize: 20,
              },
              top: '7%',
              left: '40',
            },
            series: [
              {
                name: '',
                type: 'line',
                id: 'erp',
                smooth: false,
                showAllSymbol: true,
                symbol: 'circle',
                symbolSize: 15,
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#082dc3',
                  }
                },
                itemStyle: {
                  color: '#082dc3',
                  borderColor: '#fff',
                  borderWidth: 2,
                  shadowColor: 'rgba(0, 0, 0, .3)',
                  shadowBlur: 0,
                  shadowOffsetY: 2,
                  shadowOffsetX: 2,
                },
                areaStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: 'rgba(255,115,16,0.4)'
                    },
                      {
                        offset: 1,
                        color: 'rgba(255,16,16,0)'
                      }
                    ], false),
                    shadowColor: 'rgba(255, 115, 16, 0.7)',
                    shadowBlur: 20
                  }
                },
                data: []
              }
            ],
            xAxisData: [],
            tooltip: {
              trigger: 'axis',
              textStyle: { align: 'left' },
              axisPointer: {
                lineStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0,
                      color: 'rgba(0, 255, 233,0)'
                    }, {
                      offset: 0.5,
                      color: 'rgba(255, 255, 255,1)',
                    }, {
                      offset: 1,
                      color: 'rgba(0, 255, 233,0)'
                    }],
                    global: false
                  }
                },
              },
            },
            yAxis: [{
              // type: 'category',
              type: 'value',
              axisLine: {
                show: false,
              },
              axisLabel: {
                show: true,
                margin: 20,
                textStyle: {
                  color: 'black',
                },
              },
              axisTick: {
                show: false,
              },
              // data: [0, 1, 2, 3, 4, 5, 6, 7]
              data: []
            }]
      },
      defaultSort: []
    };
  },
  computed: {
    exportLabelList() {
      return [
        { label: this.$t('table.countText'), prop: '__serial', export: { formatter: (value, row, column, index) => index + 1 } },
        ...this.labelList.filter(column => column.prop !== 'salesMonthsHistory'),
      ];
    },
    inventoryExportFileName() {
      return `Inventory Forecast Report_${moment().format('DDMMYYYY')}.csv`;
    },
  },
  mounted() {},
  methods: {
    setOperationSuggestions(value) {
      const regex_top = /increase\s+(\d+%)/;
      const regex_bottom = /reduction\s+(\d+%)/;
      if (value) {
        if (value.includes('increase')) {
          const result = value.match(regex_top);
          return `<span style='color: red;'>${result[1]} <i class='el-icon-top' style='font-size: 18px'></i></span>`;
        } else if (value.includes('reduction')) {
          const result = value.match(regex_bottom);
          return `<span style='color: green;'>${result[1]} <i class='el-icon-bottom' style='font-size: 18px'></i></span>`;
        } else {
          return value;
        }
      }
      return '———';
    },
    getWeeks() {
      const weeksArray = [];
      const currentWeek = moment().isoWeek();
      const currentYear = moment().year();
      for (let i = 0; i < 12; i++) { // 包括当前周和前11周
        let weekNumber = currentWeek - i;
        let yearNumber = currentYear;
        if (weekNumber < 1) { // 如果周数小于1，说明是上一年的最后几周
          weekNumber += moment().isoWeeksInYear(); // 加上上一年的总周数
          yearNumber--; // 年份减1
        }
        const formattedWeek = `${yearNumber}-W${weekNumber.toString().padStart(2, '0')}`; // 格式化为 'YYYY-Www' 形式，并确保周数是两位数
        weeksArray.unshift(formattedWeek); // 将格式化后的周添加到数组的开头
      }
      return weeksArray;
    },
    selectSalesMonths(value) {
      this.queryParams.salesMonthsLevels = value;
    },
    onMonth(row) {
      this.visible = true;
      this.lineChartData.xAxisData = this.getWeeks();
      this.lineChartData.series[0].data = row.split('_');
      this.lineChartData.yAxis[0].type = 'value';
      this.lineChartData.yAxis[0].data = [];
    },
    onGrade(row) {
      this.visible = true;
      const data = row.split('_');
      const salesMonthsLevel = [];
      data.forEach(item => {
        item = Number(item);
        if (item <= 1) {
          salesMonthsLevel.push('1');
      } else if (item <= 2) {
          salesMonthsLevel.push('2');
      } else if (item <= 3) {
          salesMonthsLevel.push('3');
      } else if (item <= 6) {
          salesMonthsLevel.push('4');
      } else if (item <= 9) {
          salesMonthsLevel.push('5');
      } else if (item <= 12) {
          salesMonthsLevel.push('6');
      } else {
          salesMonthsLevel.push('7');
      }
      });
      this.lineChartData.xAxisData = this.getWeeks();
      this.lineChartData.series[0].data = salesMonthsLevel;
      this.lineChartData.yAxis[0].type = 'category';
      this.lineChartData.yAxis[0].data = [0, 1, 2, 3, 4, 5, 6, 7];
    },
    handleTabClick(tab) {
      this.auditTabsValue = tab.name;
      switch (tab.name) {
        case 'FAST_MOVING':
          this.SALES_GRADE_LIST.forEach((item, index) => (item.disabled = index > 2));
          this.queryParams.salesMonthsLevels = ['1', '2', '3'];
          this.queryParams.salesTypes = ['1'];
          break;
        case 'NORMAL':
          this.SALES_GRADE_LIST.forEach((item, index) => (item.disabled = index !== 3));
          this.queryParams.salesMonthsLevels = ['4'];
          this.queryParams.salesTypes = ['2'];
          break;
        case 'SLOW_MOVING':
          this.SALES_GRADE_LIST.forEach((item, index) => (item.disabled = index <= 3));
          this.queryParams.salesMonthsLevels = ['5', '6', '7'];
          this.queryParams.salesTypes = ['3'];
          break;
        case 'LEVEL_FOUR':
          this.SALES_GRADE_LIST.forEach((item, index) => (item.disabled = index !== 3));
          this.queryParams.salesMonthsLevels = ['4'];
          this.queryParams.salesTypes = ['4'];
          break;
        default:
          this.SALES_GRADE_LIST.forEach((item) => (item.disabled = false));
          this.queryParams.salesMonthsLevels = null;
          this.queryParams.salesTypes = ['1', '2', '3', '4'];
      }
      this.reFresh();
    },
    sortChange (column) {
      switch (column.field) {
        case 'skuCode':
          this.queryParams.skuSort = column.order;
          break;
        case 'shipmentQty':
          this.queryParams.shipmentQtySort = column.order;
          break;
        case 'onHandQty':
          this.queryParams.onHandQtySort = column.order;
          break;
        case 'skuAvgDaySales':
          this.queryParams.skuAvgDaySalesSort = column.order;
          break;
        case 'salesMonths':
          this.queryParams.salesMonthsSort = column.order;
          break;
      }
      this.defaultSort = column.sortList.map(item => { return { field: item.field, order: item.order}; });
      this.$refs.BjPage.fetchData();
    },
    clearQueryParams() {
      this.queryParams.skuCode = null;
      this.queryParams.skuName = null;
      this.salesMonthsLevels = null;
      this.queryParams.skuSort = null;
      this.queryParams.shipmentQtySort = null;
      this.queryParams.onHandQtySort = null;
      this.queryParams.skuAvgDaySalesSort = null;
      this.queryParams.salesMonthsSort = null;
      this.defaultSort = [];
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.clearQueryParams();
      return new Promise(resolve => {
        resolve();
      });
    },
    resetAfterExport() {
      this.$refs.BjPage.onResetQuery();
    },
  },
};
</script>
<style scoped lang="scss">
.app-container {
  .manual {
    .title {
      text-indent: 0em;
    }
    .formula {
        color: #8f8f9d;
        margin:0;
    }
    p {
      text-indent: 2em;
      line-height: 18px;
    }
  }
}
</style>
